import script from "./UIIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIIcon.vue?vue&type=script&lang=ts&setup=true"

import "./UIIcon.vue?vue&type=style&index=0&id=d6030060&lang=stylus"

const __exports__ = script;

export default __exports__